export default "<app-billing-tab >\r\n</app-billing-tab>\r\n";